import CenterList from './List';
import CenterForm from './Form';


export default {
    path: 'cadastros',
    redirect: '/cadastros/central-atendimento',
    name: 'Cadastro Central Atendimento',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'central-atendimento',
            name: 'list-center',
            component: CenterList,
            meta: {
                requiresAuth: true,
                label: 'Listar Central Atendimento'
            }
        },
        {
            path: 'central-atendimento/novo',
            name: 'new-center',
            component: CenterForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Central Atendimento'
            }
        },
        {
            path: 'central-atendimento/:id',
            name: 'edit-center',
            component: CenterForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Central Atendimento'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/center/router.js